export default {
  methods: {
    setChart(myChart, data) {
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(0,0,0,0)"
            }
          },
          backgroundColor: "#fff",
          borderColor: "#eef1f5",
          borderWidth: 1,
          formatter: params => {
            let str = "";
            params.forEach(parma => {
              let color = parma.seriesName === "成功" ? "#73b3f2" : "#ee9896";
              str += `${parma.seriesName}: <span style="color: ${color}">${parma.value} </span>`;
            });
            return str;
          },
          textStyle: {
            color: "#8391a5"
          },
          padding: [5, 10]
        },
        legend: {
          bottom: 0,
          itemGap: 20,
          inactiveColor: "#eef1f5",
          data: [
            { name: "成功", icon: "circle", textStyle: { color: "#8391a5" } },
            { name: "失败", icon: "circle", textStyle: { color: "#8391a5" } }
          ]
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        grid: {
          left: "20px",
          right: "20px",
          bottom: "23px",
          top: "20px",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5"
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5"
          },
          splitLine: {
            lineStyle: {
              color: "#eef1f5"
            }
          }
        },
        color: ["#73b3f2", "#ee9896"]
      };
      options.series = data.series;
      options.xAxis.data = data.data;
      myChart.setOption(options, false);
    },
    setChart2(myChart, data) {
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(0,0,0,0)"
            }
          },
          backgroundColor: "#fff",
          borderColor: "#eef1f5",
          borderWidth: 1,
          formatter: params => {
            let str = "";
            params.forEach(parma => {
              str += `${parma.axisValue}<br />${parma.seriesName}: <span style="color: #73b3f2">${parma.value} </span>`;
            });
            return str;
          },
          textStyle: {
            color: "#8391a5"
          },
          padding: [5, 10]
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        grid: {
          left: "20px",
          right: "20px",
          bottom: "0",
          top: "20px",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5",
            rotate: 30,
            formatter: function(value) {
              return value.substring(0, 5);
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5"
          },
          splitLine: {
            lineStyle: {
              color: "#eef1f5"
            }
          }
        },
        color: ["#ee9896"]
      };
      options.series = data.series;
      options.xAxis.data = data.data;
      myChart.setOption(options, false);
    },
    setChart4(myChart, data) {
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(0,0,0,0)"
            }
          },
          backgroundColor: "#fff",
          borderColor: "#eef1f5",
          borderWidth: 1,
          formatter: params => {
            let str = "";
            params.forEach(parma => {
              str += `${parma.axisValue}<br />${parma.seriesName}: <span style="color: #73b3f2">${parma.value} </span>`;
            });
            return str;
          },
          textStyle: {
            color: "#8391a5"
          },
          padding: [5, 10]
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        grid: {
          left: "20px",
          right: "20px",
          bottom: "0",
          top: "20px",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5",
            rotate: 30
            // formatter: function(value, index) {
            //   return value.substring(0, 5)
            // }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#8391a5"
          },
          splitLine: {
            lineStyle: {
              color: "#eef1f5"
            }
          }
        },
        color: ["#73b3f2", "#ee9896"]
      };
      options.series = data.series;
      options.xAxis.data = data.data;
      myChart.setOption(options, false);
    }
  }
};
